export default "__VITE_ASSET__CsAztw8U__"